import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 MoneyMind. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
